import { useRef, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Divider,
  Button,
  Card,
  Popover,
  Typography,
  Checkbox,
  Alert
} from 'antd'
import { generateFieldData } from './helpers'
import { Check, Edit, X } from 'react-feather'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { setNamespacesEnabled, setNamespaces } from 'Actions/explore'
import { Namespaces } from 'Model'
import RegistryForm from './RegistryForm'
import WeaverService from 'Services/WeaverService'
import Feather from '@sysunite/react-feather'
{ Paragraph, Text } = Typography

helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph style={{ width: 500, lineHeight: '1.6rem' }}>
    The <Text code>namespaces</Text> are used to give <Text mark>names, or labels</Text> readable values to elements within a project
    if the value corresponds with one of the configured namespaces.
    Several <Text code>namespaces</Text> can be configured.
  </Paragraph>
  <Text type="secondary">
    Note: Changing this will not actually update anything in the database, just how the app reads from the database.
    So, if you change this just to explore, and then later change it back, the data and app views will look the same as they did previously.
  </Text>
</div>)

info = (
  <Popover
    content={helpText}
    title='Name Keys'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

NamespacesPanel = ({ namespacesEnabled, namespaces, setNamespacesEnabled, setNamespaces }) ->

  [isEditing, setIsEditing] = useState(false)
  [loading, setLoading] = useState(true)
  [node, setNode] = useState(undefined)
  [dataMap, setDataMap] = useState(namespaces)
  [newMapping, setNewMapping] = useState(undefined)
  [error, setError] = useState(undefined)

  formRef = useRef()

  useEffect( ->
    ( ->
      node = await Namespaces.load()
      setNode(node)
      setLoading(false)
    )()
    undefined
  , [])

  validatePrefix = (prefix) ->
    if not prefix?
      throw new Error('Prefix should not be empty')
    if prefix.charAt(prefix.length - 1) isnt ':'
      throw new Error('Prefix should have : in the end')
    if prefix.split(':').length > 2
      throw new Error('Prefix should have only one :')

  validateNamespace = (namespace) ->
    if not namespace? or namespace is ''
      throw new Error('Namespace key should not be empty')
    if namespace.charAt(namespace.length - 1) not in ['/', '#']
      throw new Error('Namespace should end in / or #')

  validateUniquePrefixes = (namespaceMap) ->
    dups = Object.entries(_.countBy(_.values(namespaceMap)))
      .reduce((acc, [key, val]) ->
        if val > 1 then acc.concat(key) else acc
    , [])
    if dups.length > 0
      throw new Error("There are duplicate prefixes: [ #{dups} ]")

  generateNamespaceMap = ->
    { namespaces } = formRef.current.getFieldsValue()
    namespaceMap = _.reduce(namespaces, (acc, value) ->
      validatePrefix(value.value)
      validateNamespace(value.key)
      {
        acc...
        [value.key]: value.value
      }
    , {})
    validateUniquePrefixes(namespaceMap)
    namespaceMap

  resetForm = (fieldData) ->
    formRef.current?.resetFields()
    formRef.current?.setFields(fieldData)

  useEffect( ->
    fieldData = generateFieldData(dataMap, 'namespaces')
    resetForm(fieldData)
  , [isEditing])

  actions = (
    if isEditing
      [
        <Button
          type="text"
          onClick={ ->
            try
              namespaceMap = generateNamespaceMap()
            catch e
              setError(e.message)
              return
            await node.updateMap(namespaceMap)
            setNamespaces(namespaceMap)
            setDataMap(namespaceMap)
            setIsEditing(false)
            setError(undefined)
          }
        >
          <Check />
        </Button>
        <Button
          type="text"
          onClick={ ->
            setDataMap(node.map())
            setIsEditing(false)
          }
        >
          <X />
        </Button>
      ]
    else
      [
        <Button
          type="text"
          disabled={!WeaverService.userCanEdit()}
          onClick={ -> setIsEditing(true)}
        >
          <Edit />
        </Button>
      ]
  )
  <Card
    title="Namespaces"
    loading={loading}
    actions={actions}
    extra={info}
    size="small"
    id="Namespaces"
  >
    <span>
      <Checkbox
        style={{ marginRight: 5 }}
        onChange={({ target: { checked } }) ->
          await node.updateEnabled(checked)
          setNamespacesEnabled(checked)
        }
        checked={namespacesEnabled}
      />
      Enable namespace mapping to improve readability?
    </span>
    <Divider />
    <RegistryForm
      data={dataMap}
      formRef={formRef}
      formName="namespaces"
      isEditing={isEditing}
      item="namespace"
    />
  { if error then <Alert message="Error generating namespace" description={ error } type="error" /> }
  </Card>

export default connect(({ explore }) ->
  { namespaces: explore.namespaces, namespacesEnabled: explore.namespacesEnabled }
, { setNamespacesEnabled, setNamespaces })(NamespacesPanel)
